import React from 'react';
import SensorsExplorerPage from './pages/SensorsExplorerPage';
import SensorsMasterConfigurationsPage from './pages/SensorsMasterConfigurationsPage';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';

const samplingRoutes = [
    { path: '/sensors-explorer', element: <SensorsExplorerPage />, visibility: 'private' },
    { path: '/sensors-master-configurations', element: <SensorsMasterConfigurationsPage />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];

const B2BSampling = () => {
    return <B2BRoutesModule routes={samplingRoutes} />;
};

export default B2BSampling;